import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { FiUsers } from "react-icons/fi";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdOutlinePersonOff } from "react-icons/md";
import { FiUserPlus } from "react-icons/fi";
import { IoTrendingDown } from "react-icons/io5";

export default function EmployeeStats() {
  const stats = [
    {
      title: "Total Employee",
      count: "1007",
      icon: <FiUsers />,
      bg: "bg-dark-custom",
      badge: "badge-purple",
    },
    {
      title: "Active",
      count: "1007",
      icon: <HiOutlineUserGroup />,
      bg: "bg-success-custom",
      badge: "badge-primary-soft",
    },
    {
      title: "InActive",
      count: "1007",
      icon: <MdOutlinePersonOff />,
      bg: "bg-danger-custom",
      badge: "badge-dark-soft",
    },
    {
      title: "New Joiners",
      count: "67",
      icon: <FiUserPlus />,
      bg: "bg-info-custom",
      badge: "badge-secondary-soft",
    },
  ];

  return (
    <Row className="g-3">
      {stats.map((item, index) => (
        <Col lg={3} md={6} key={index} className="d-flex">
          <Card className="flex-fill stat-card">
            <Card.Body className="d-flex align-items-center justify-content-between">

              {/* LEFT */}
              <div className="d-flex align-items-center">
                <div className={`avatar-circle ${item.bg}`}>
                  {item.icon}
                </div>

                <div className="ms-3">
                  <p className="stat-title mb-1">{item.title}</p>
                  <h4 className="mb-0">{item.count}</h4>
                </div>
              </div>

              {/* RIGHT BADGE */}
              <span className={`stat-badge ${item.badge}`}>
                <IoTrendingDown className="me-1" />
                +19.01%
              </span>

            </Card.Body>
          </Card>
        </Col>
      ))}
      <style>
          {
               `
               /* CARD */
.stat-card {
  border-radius: 7px;
  border: 1px solid #e8e3e3;
  box-shadow: 0 3px 6px rgba(53, 53, 53, 0.04);
}

/* AVATAR */
.avatar-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
}

/* COLORS (match image exactly) */
.bg-dark-custom {
  background: #1e1e2d;
}

.bg-success-custom {
  background: #22c55e;
}

.bg-danger-custom {
  background: #ef4444;
}

.bg-info-custom {
  background: #3b82f6;
}

/* TEXT */
.stat-title {
  font-size: 13px;
  color: #6c757d;
}

/* BADGES */
.stat-badge {
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

/* badge colors like screenshot */
.badge-purple {
  background: #f3e8ff;
  color: #9333ea;
}

.badge-primary-soft {
  background: #e0f2fe;
  color: #0284c7;
}

.badge-dark-soft {
  background: #e5e7eb;
  color: #374151;
}

.badge-secondary-soft {
  background: #f1f5f9;
  color: #475569;
}

/* MOBILE */
@media (max-width: 768px) {
  .avatar-circle {
    width: 45px;
    height: 45px;
  }

  .stat-title {
    font-size: 12px;
  }

  .stat-badge {
    font-size: 11px;
    padding: 5px 8px;
  }
}`
          }
      </style>
    </Row>
  );
}